import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../pages/Index'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'index', component: Index},
  { path: '/product', name: 'product', component: () => import('@/pages/Product.vue')},
  { path: '/product/:name', name: 'productDetail', component: () => import('@/pages/ProductDetail.vue')},
  { path: '/solution', name: 'solutions', component: () => import('@/pages/Solutions.vue')},
  { path: '/service', name: 'service', component: () => import('@/pages/Service.vue')},
  { path: '/ourcase', name: 'Ourcase', component: () => import('@/pages/Ourcase.vue')},
  { path: '*',name: '404', component: () => import('@/pages/404.vue')}
]
const router = new VueRouter({
  mode:'history',
    routes,
    //base:'website'
})

// router.beforeEach((to, from, next) => {
//   window.document.title = to.meta.title == undefined ? '中凯顺' : to.meta.title
//   next()
// })
export default router


// WEBPACK FOOTER //
// ./src/router/router.js